import { bankTransfer } from './type';
import StorageService from '../services/storage.service';
import UserInvestmentService from '../services/user-investment.service';
import { Alert } from '../services/notiflix.service';

export const setBankTransfer = (transaction) => (dispatch) => {
  try {
    dispatch({
      type: bankTransfer.SET_BANK_TRANSFER,
      payload: transaction,
    });
  } catch (error) {
    Alert.error(error.message);
  }
};

export const clearBankTransfer = () => (dispatch) => {
  try {
    const bankTransferData = {
      selectedTransaction: null,
      pendingTransactions: [],
    };
    StorageService.setObject('bankTransfer', bankTransferData);

    dispatch({
      type: bankTransfer.CLEAR_BANK_TRANSFER,
      payload: null,
    });
  } catch (error) {
    Alert.error(error.message);
  }
};

export const clearSelectedTransaction = () => (dispatch) => {
  try {
    const existing = StorageService.getObject('bankTransfer') || {};

    const updatedStorage = {
      ...existing,
      selectedTransaction: null,
    };

    StorageService.setObject('bankTransfer', updatedStorage);

    dispatch({
      type: bankTransfer.CLEAR_SELECTED_TRANSACTION,
      payload: null,
    });
  } catch (error) {
    Alert.error(error.message);
  }
};

export const pendingBankTransfer = () => async (dispatch) => {
  try {
    const response = await UserInvestmentService.getMolliePaymentList();

    const updatedData = response.data.map((payment) => ({
      order_id: payment?.order_id,
      amount: payment?.amount,
      bankAccount: payment?.consumerAccount?.bankAccount,
      bankName: payment?.consumerAccount?.bankName,
      paymentReference: payment?.consumerAccount?.transferReference,
      expiryDate: payment?.expiryDate,
      project_id: payment?.project_id,
      projectName: payment?.projectName,
    }));

    const existing = StorageService.getObject('bankTransfer') || {};
    const updatedStorage = {
      ...existing,
      pendingTransactions: updatedData,
    };

    StorageService.setObject('bankTransfer', updatedStorage);

    dispatch({
      type: bankTransfer.UPDATE_PENDING_TRANSACTIONS,
      payload: updatedData,
    });
    dispatch(clearSelectedTransaction());
  } catch (error) {
    Alert.error(error.message);
  }
};
